import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useComplianceStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in PayClassifications loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in PayClassifications loader'
  )

  const getPayClassifications = useComplianceStore
    .getState()
    .getPayClassifications()

  return defer({
    data: Promise.all([getPayClassifications])
      .then(() => true)
      .catch((error) => {
        logger.error('Pay Classifications Promise.all error', error)
        return false
      }),
  })
}
